var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 17.8498C16.9999 16.6636 16.9999 16.0705 16.8535 15.5878C16.5239 14.5012 15.6735 13.6508 14.5869 13.3212C14.1043 13.1748 13.5111 13.1748 12.3249 13.1748H8.07491C6.88868 13.1748 6.29556 13.1748 5.81293 13.3212C4.72629 13.6508 3.87594 14.5012 3.54631 15.5878C3.3999 16.0705 3.3999 16.6636 3.3999 17.8498M14.0249 6.37481C14.0249 8.4873 12.3124 10.1998 10.1999 10.1998C8.08742 10.1998 6.3749 8.4873 6.3749 6.37481C6.3749 4.26232 8.08742 2.5498 10.1999 2.5498C12.3124 2.5498 14.0249 4.26232 14.0249 6.37481Z",
    stroke: "#142C4B",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f79ab9294a4fc93ad436672690aff356.svg";
export { ForwardRef as ReactComponent };